import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "smoking_detection",
  localization: {
    en: {
      title: "Smoking detected",
      settingsHeader: "Smoking Detection",
    },
    fr: {
      title: "Fumeur détecté",
      settingsHeader: "Détection de Fumer",
    }
  },
  proto: {
    name: "EVENT_RAVEN_SMOKING_DETECTED",
    value: 138
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}
